import {AnalysisGraphQL, GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getTableLineageAncestorSteps} from 'pipelines/StepLineageUtils';

export function getAncestorStepsByType(
  analysis: AnalysisGraphQL,
  step: GetAnalysisPipelineStep,
  stepType: PipelineStepType
): Array<GetAnalysisPipelineStep> {
  return getTableLineageAncestorSteps(analysis, step).filter((step) => step.definition.stepType === stepType);
}
